import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateBackgroundIdentificationItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import DocumentTemplateForm from './document-template-form';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function EditBackgroundIdentificationTemplate({
  dismiss,
  item,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.updateBackgroundIdentificationItemTemplate.errors) {
      addErrorsToForm(
        form,
        response.updateBackgroundIdentificationItemTemplate.errors
      );

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateBackgroundIdentification] = useMutation(
    UpdateBackgroundIdentificationItemTemplate,
    {
      onCompleted: handleMutationCompletion,
      onError: () =>
        createMessage(
          'error',
          'Failed to update Compliance Item. Please try again.'
        ),
    }
  );

  const handleSubmit = (values) => {
    updateBackgroundIdentification({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    documentTemplateId: item.documentTemplate.id,
    documentTemplateSubtype: item.documentTemplateSubtype,
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <DocumentTemplateForm
      categories={['background', 'identity', 'facility_required']}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      showExpiration
      form={form}
    />
  );
}

EditBackgroundIdentificationTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
